'use strict';

var validateImage = require('../components/validateImage');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */

function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    lazyLoadInstance.update();
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find(
            '.' + $(this)[0].className.replace(/ /g, '.')
        );
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });
    if ($results.find('.refinement-bar').length > 0) {
        updateDom($results, '.refinement-bar .refinements');
        initProductTilejs();
    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(
    response,
    countflag,
    lastfilterflag
) {
    var $results = $(response);
    var specialHandlers = {
        '.refinement-bar .refinements': handleRefinements,
    };
    if ($results.find('.refinement-bar').length > 0) {
        ['.filter-bar'].forEach(function (selector) {
            updateDom($results, selector);
        });
    }
    // Update DOM elements that do not require special handling
    ['.filter-footer', '.filter-apply-button-container'].forEach(function (
        selector
    ) {
        updateDom($results, selector);
    });

    if (!countflag || lastfilterflag) {
        ['.grid-header', '.header-bar', '.header.page-title', '.show-more'].forEach(
            function (selector) {
                updateDom($results, selector);
            }
        );
        updateDom($results, '.product-grid');
        var $resultInDiv = $('<div>').append($results);
        updateDom($resultInDiv, '.search-results-header');
        if ($('.search-results-header h1').text().trim().length > 0) {
            document.title = $('.search-results-header h1').text().trim()
        }
    }

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
    validateImage.validatePictures();
    displaySearchRefinement();

    if ($('.filter-bar li button').length > 0) {
        $('.secondary-bar button.reset').attr('disabled', false);
    } else {
        $('.secondary-bar button.reset').attr('disabled', true);
    }
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function initProductTilejs() {
    swatchAdaptScreensize();
}

function swatchAdaptScreensize() {
    $(window).on('load resize orientationchange', function () {
        var colorSwatches = $('.swatches');
        if ($(window).width() < 600) {
            colorSwatches.children("span:nth-child(n+11):not('.more')").hide();
        } else {
            colorSwatches.children().show();
        }
    });
}

function updatePageUrlParams(loadMoreUrl) {
    var queryString =
        loadMoreUrl && loadMoreUrl.indexOf('?') > -1
            ? loadMoreUrl.split('?')[1]
            : window.location.search.slice(1);
    var params = getQueryParams(queryString);

    if (params) {
        var pageSize = params.sz;
        var resultsCount = params.start;
        if (resultsCount && resultsCount.length > 0) {
            resultsCount = parseInt(resultsCount) + parseInt(pageSize);
            queryString = queryString.replace(/start=[0-9][0-9]/g, 'start=0');
            queryString = queryString.replace(/sz=[0-9][0-9]/g, 'sz=' + resultsCount);
        }
        queryString = queryString.replace(/\A?cgid=[^&]+&*/g, '');
        history.replaceState('', '', '?' + queryString);
    }
}

/**
 * Check for filter combination that returns 0 products
 * Clean the refinement URL
 * @param {string} refinementUrl
 * @param {object} jQuery object
 * @returns {string} updated refinement Url
 */
function cleanRefinementUrl(refinementUrl, $this) {
    var updatedUrl = "";
    var appliedFilters = {};
    var refinementFilters = {};
    var updatedFilters = {};
    var $appliedFilters = $('.drawer-footer .filter-bar li');
    if ($appliedFilters.length > 0) {
        var refinementType;
        var refinementValue;
        $appliedFilters.each(function () {
            // push filter type as keys
            refinementType = $(this).find('button').attr('refinement-type');
            // push applied filter values
            refinementValue = $(this).find('span:first').text();
            if (refinementType in appliedFilters) {
                appliedFilters[refinementType] += '|' + refinementValue;
            } else {
                appliedFilters[refinementType] = refinementValue;
            }
        });
    }
    if (refinementUrl.indexOf("prefn") > -1) {
        var pieces = refinementUrl.split("prefn");
        for (var i = 1; i < pieces.length; i++) {
            var piece = pieces[i];
            var refinementType = (piece.split('&')[0]).replace(/[^A-Za-z]/, '').replace('=', '');
            var refinementValue = decodeURIComponent(piece.split('&')[1].split('=')[1]);
            refinementFilters[refinementType] = refinementValue;
        }
    }
    if (Object.keys(refinementFilters).length > 0) {
        Object.keys(refinementFilters).forEach(function (refinementFilter, index) {
            var refinementValue = refinementFilters[refinementFilter];
            if (refinementFilter in appliedFilters) {
                var appliedValue = appliedFilters[refinementFilter]
                if (refinementValue !== appliedValue) {
                    var deselectedValue = $this.find('span:first').text().trim().length > 0 ? $this.find('span:first').text().trim() : $this.find('.refinement-attribute__name').text().trim();
                    if (deselectedValue.toLowerCase() !== appliedValue.toLowerCase()) {
                        updatedFilters[refinementFilter] = refinementValue;
                    } else {
                        delete updatedFilters[refinementFilter]
                    }
                } else {
                    updatedFilters[refinementFilter] = refinementValue;
                }
            }
        })
    }

    if (Object.keys(updatedFilters).length > 0) {
        // check for category search vs query search
        if (refinementUrl.indexOf("q=") === -1) {
            updatedUrl = refinementUrl.split('&', 1);
        } else {
            var delimiter = '&';
            var start = 2;
            var tokens = refinementUrl.split(delimiter).slice(0, start);
            updatedUrl = tokens.join(delimiter);
        }

        Object.keys(updatedFilters).forEach(function (updatedFilter, index) {
            updatedUrl += '&' + 'prefn' + (index + 1) + '=' + updatedFilter;
            updatedUrl += '&' + 'prefv' + (index + 1) + '=' + encodeURIComponent(updatedFilters[updatedFilter]);
        })
    }
    return updatedUrl !== '' ? updatedUrl : refinementUrl;
}

function getQueryParams(queryString) {
    if (queryString == null || queryString.length == 0) {
        return null;
    }
    let result = {};
    let queryParamArray = queryString.split('&');

    queryParamArray.forEach(function (queryParam) {
        let item = queryParam.split('=');
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
}

/**
 * Displays the Search Refinement input
 */
function displaySearchRefinement() {
    var refinements = $('.refinements .refinement');
    if (refinements) {
        for (var i = 0; i < refinements.length; i++) {
            var refinement = refinements[i];
            var $refinement = $(refinement);
            var refinementValues = $refinement
                ? $refinement.find('.values li')
                : null;
            if (refinementValues && refinementValues.length > 5) {
                $refinement.find('.js-refinementSearch').removeClass('d-none');
            }
        }
    }
}

/**
 * Updates the Sort Button UI
 */
function updateSortButton(sortRuleDisplayName) {
    $('.sort-button-container span')
        .empty()
        .html(' : ' + sortRuleDisplayName);
}

// to scroll animation functionality

function scrollToView(selector) {
    var headerHeight = $("header.main-header").height();

    if (window.innerWidth < 544) { // case handling for retracting header behaviour in mobile
        var scrollDistance = $(window).scrollTop() - $(selector).offset().top;
        if (scrollDistance < 0) {
            headerHeight = 0;
        }
    }
    $('html, body').animate({
        scrollTop: $(selector).offset().top - headerHeight
    }, 1000);
}

function showYotpoStarReviews() {

     //removing star reviews text
     var reviewsCount = $('.product-tile .text-m');

     if(reviewsCount.length > 0) {
         for (var i = 0; i < reviewsCount.length; i++) {
             var review = reviewsCount[i];
             var text = review.textContent.trim();
             if (text.match(/\d+\s*(Review|Reviews)$/)) {
                 var newText = text.replace(/\s*(Review|Reviews)$/, '');
                 review.textContent = newText;
                 $('.product-rating').show();
                 $(review).addClass('d-block');
             }
         }
     }else {
        $('.product-rating').hide();
     }

}
/*
 * Adding ecommerce impressions data for PLP pages (Both category and Search)
 */
$(window).on('load', function () {

    showYotpoStarReviews();

    // push 'search' event only for PLPs or search pages
    // if condition not added, 'search' event with 0 impressions gets pushed for homepage and for PDP
    if ($('.page[data-action="Search-Show"]').length > 0) {
        var obj = {
            'event': 'search',
            'ecommerce': {
                'impressions': []
            }
        };
        if ($('.search-results').data('searchterm')) {
            obj.ecommerce.searchTerm = 'q=' + $('.search-results').data('searchterm');
        } else {
            obj.ecommerce.categoryID = $('.search-results').data('categoryid');
            obj.ecommerce.categoryName = $('.search-results').data('categoryname');
        }

        if ($('.product-tile-section').length > 0) {
            $.each($('.product-tile-section'), function (index) {
                var $ele = $(this).find('.product');
                var product;
                if (window.gtmGA4Enabled) {
                    product = $ele.data('gtmga4data') || $.parseJSON($ele.attr('data-gtmga4data'));
                    product.index = ++index;
                } else {
                    product = $ele.data('gtmdata') || $ele.attr('data-gtmdata') && $ele.attr('data-gtmdata') !== '' ? $.parseJSON($ele.attr('data-gtmdata')) : {};
                    product.list = 'Search Results';
                    product.position = ++index;
                }

                obj.ecommerce.impressions.push(product);
            });
        }
        dataLayer.push(obj);
    }

    // enable or, disable Clear All button when we land from Shop By Color section
    if ($('.filter-bar li button').length > 0) {
        $('.secondary-bar button.reset').attr('disabled', false);
    } else {
        $('.secondary-bar button.reset').attr('disabled', true);
    }
});

$(document).on('click', '.sort-button-container .sort-button', function (e) {
    var value = $('.filter-and-sort .sort-button-container button span')[0].innerText.toLowerCase();
    var orderItem = $('input[name="sort-order"]');
    orderItem.prop('checked', false);
    $('.productSortOption').attr('aria-checked', 'false');

    orderItem.each(function () {
        if (value.indexOf($(this).data('displayname').toLowerCase()) > 0) {
            $(this).prop('checked', true);
            $(this).closest('.productSortOption').attr('aria-checked', 'true');
        }
    });
});

$(document).on('click', '.filter-button', function () {
    $('.filter-drawer .refinement').each(function () {
        var $refinement = $(this);
        if ($refinement.find('button .selected').length || $refinement.data('openned-accordian') === true) {
            $refinement.addClass('active');
            $refinement.find('.title').attr('aria-expanded', true);
        } else {
            $refinement.removeClass('active');
            $refinement.find('.title').attr('aria-expanded', false);
        }
    });
});

$(document).on({
    mouseenter: function () {
        var $swatches = $(this).find('.color-swatches');
        var $colorSwatchInfo = $(this).find('.color-swatch-info');
        if ($swatches.attr('data-toggle-swatch-on-hover') === "true" && window.matchMedia('(min-width:768px)').matches && !$colorSwatchInfo.hasClass('color-swatch-hide')) {
            $swatches.removeClass('color-swatch-hide');
        } else if ($swatches.attr('data-toggle-swatch-on-hover-mobile') === "true" && window.matchMedia('(max-width:768px)').matches && !$colorSwatchInfo.hasClass('color-swatch-m-hide')) {
            $swatches.removeClass('color-swatch-m-hide');
        }
    },
    mouseleave: function () {
        var $swatches = $(this).find('.color-swatches');
        var $colorSwatchInfo = $(this).find('.color-swatch-info');
        if ($swatches.attr('data-toggle-swatch-on-hover') === "true" && window.matchMedia('(min-width:768px)').matches && !$colorSwatchInfo.hasClass('color-swatch-hide')) {
            $swatches.addClass('color-swatch-hide');
        } else if ($swatches.attr('data-toggle-swatch-on-hover-mobile') === "true" && window.matchMedia('(max-width:768px)').matches && !$colorSwatchInfo.hasClass('color-swatch-m-hide')) {
            $swatches.addClass('color-swatch-m-hide');
        }
    }
}, ".product-tile");

$(document).on('focus', '.product-tile, .color-swatches .swatch-circle', function(e) {
	var $swatches = $(this).find('.color-swatches');
    var $colorSwatchInfo = $(this).find('.color-swatch-info');
    if ($swatches.attr('data-toggle-swatch-on-hover') === "true" && window.matchMedia('(min-width:768px)').matches && !$colorSwatchInfo.hasClass('color-swatch-hide')) {
        $('.product-tile .color-swatches').addClass('color-swatch-hide');
        $swatches.removeClass('color-swatch-hide');
    } else if ($swatches.attr('data-toggle-swatch-on-hover-mobile') === "true" && window.matchMedia('(max-width:768px)').matches && !$colorSwatchInfo.hasClass('color-swatch-m-hide')) {
        $('.product-tile .color-swatches').addClass('color-swatch-m-hide');
        $swatches.removeClass('color-swatch-m-hide');
    }
});

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('#product-search-results').on('click', 'button.filter-results', function () {
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('#product-search-results').on(
            'click',
            '.refinement-bar button.close, .modal-background',
            function () {
                $('.refinement-bar').siblings().attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.row')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.tab-pane.active')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.container.search-results')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.btn.filter-results').focus();
            }
        );
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).on('resize', function (e) {
            e.preventDefault();

            setTimeout(function () {
                if (window.matchMedia('(min-width:768px)').matches) {
                    $('.modal-background').hide();
                    $('.refinement-bar').removeAttr('style');
                    $('.refinement-bar').siblings().attr('aria-hidden', false);
                    $('.refinement-bar')
                        .closest('.row')
                        .siblings()
                        .attr('aria-hidden', false);
                    $('.refinement-bar')
                        .closest('.tab-pane.active')
                        .siblings()
                        .attr('aria-hidden', false);
                    $('.refinement-bar')
                        .closest('.container.search-results')
                        .siblings()
                        .attr('aria-hidden', false);
                } else if (window.matchMedia('(max-width:767px)').matches) {
                    $('.refinement-bar button.close').trigger('click');
                }
            }, 100);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(document).on('click', '.sort-apply-button', function (e) {
            e.preventDefault();
            var sortOptionElement = $('input[name="sort-order"]:checked');
            var value = sortOptionElement[0].value;
            var sortRuleDisplayName = sortOptionElement.data('displayname');
            $.spinner().start();
            $(this).trigger('search:sort', value);
            var sortUrl = value;

            if (sortUrl.includes('&start')) {
                sortUrl = sortUrl.substring(0, sortUrl.indexOf('&start'));
            } else if (sortUrl.includes('&sz')) {
                sortUrl = sortUrl.substring(0, sortUrl.indexOf('&sz'));
            }

            $.ajax({
                url: sortUrl,
                data: { selectedUrl: sortUrl },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    updatePageUrlParams(sortUrl);
                    lazyLoadInstance.update();
                    validateImage.validatePictures();
                    updateSortButton(sortRuleDisplayName);
                    // load star ratings after sorting
                    yotpo.refreshWidgets();

                    setTimeout(function () {
                        showYotpoStarReviews();
                    }, 700);
                    $.spinner().stop();
                    $('#sort-product-list-drawer').drawer('hide');
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
        $('body').on('change', '[name=sort-order]', function (e) {
            var orderItem = $('input[name="sort-order"]');
            orderItem.each(function () {
                if($(this).prop('checked')){
                    $(this).closest('.productSortOption').attr('aria-checked', 'true');
                }else{
                    $(this).closest('.productSortOption').attr('aria-checked', 'false');
                }
            });

            if ($(this).prop('checked') && $('.sort-apply-button').is('[disabled]')) {
                $('.sort-apply-button').removeAttr('disabled');
            }
        });


        $(".productSortOption").keydown(function (e) {
            if (e.which === 13) {
                $(this).find('input[name="sort-order"]').click();
            }
        });
    },

    showMore: function () {
        // Show more products
        $('.show-more').on('click', 'button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');

            e.preventDefault();
            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    updatePageUrlParams(showMoreUrl);
                    lazyLoadInstance.update();
                    validateImage.validatePictures();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },
    boutiqueFilter: function () {
        function updateBoutiqueBanner(selectedValue) {
            if (selectedValue == null || !selectedValue.length) {
                return;
            }

            $('.boutique-banner__image').addClass('d-none');
            $('.boutique-banner')
                .find('.boutique-banner__image[data-banner="' + selectedValue + '"]')
                .removeClass('d-none');
        }

        $('select.js-boutique-filter').on('change', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var selectedValue = $(this).val();
            var selectedDesktopFilter = $('.boutique-filter__container').find(
                '.boutique-filter[data-value="' + selectedValue + '"]'
            );

            if (!selectedDesktopFilter.hasClass('active')) {
                $('.boutique-filter__container')
                    .find('.boutique-filter[data-value="' + selectedValue + '"]')
                    .click();
                updateBoutiqueBanner(selectedValue);
            }
        });

        $('.boutique-filter').on('click', function () {
            if (!$(this).hasClass('active')) {
                var currentValue = $(this).data('value');
                $('.boutique-filter').removeClass('active');
                $(this).addClass('active');

                // Update dropdown
                var selectValue = $('select.js-boutique-filter').val();
                if (selectValue != currentValue) {
                    $('select.js-boutique-filter').selectpicker('val', currentValue);
                    updateBoutiqueBanner(currentValue);
                }
            }
        });

        $('.slot-boutique.container, .featured-product__container').on(
            'click',
            '.custom-search-filter',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                var refinementUrl = $(this).data('url');

                $.when(
                    $.ajax({
                        url: refinementUrl,
                        data: {
                            page: '0',
                            selectedUrl: refinementUrl,
                        },
                        method: 'GET',
                        success: function (response) {
                            // Replace refinement column
                            var $html = $('<div>').append($.parseHTML(response));
                            var $htmlRefinement = $html.find('.refinement-bar').children();
                            $('.refinement-bar').html($htmlRefinement);
                            updatePageUrlParams(refinementUrl);
                            parseResults(response, false, false, false);
                            $.spinner().stop();
                        },
                        error: function () {
                            $.spinner().stop();
                        },
                    })
                );
            }
        );
    },
    fetchCount: function () {
        $('#product-search-results').on(
            'click',
            '.refinements li button, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                $.spinner().start();
                var $this = $(this);
                $(this).trigger('search:filter', e);
                var countflag = false;
                var refinementUrl = $(this).data('href');
                var parentDiv = $this.parents('.refinements').length > 0 ? '.refinements' : '.filter-bar';

                // check for combination of filters that return 0 products
                // if found, update the url with correct filters
                if ($this.parents().hasClass('filter-bar') || $this.children('span').hasClass('selected')) {
                    var updatedUrl;
                    updatedUrl = cleanRefinementUrl(refinementUrl, $this);
                    refinementUrl = updatedUrl !== '' ? updatedUrl : refinementUrl;
                }

                // Check for last filter to be cleared
                var lastfilterflag = false;
                var $filterElements = $('.refinement-bar').find(
                    'li button span.selected'
                );
                if (
                    $(this).parents().closest('.drawer-footer').length > 0 &&
                    $filterElements.length === 1
                ) {
                    lastfilterflag = true;
                }

                // Extract the query parameters from the URL
                var queryParams = new URLSearchParams(refinementUrl.slice(refinementUrl.indexOf('?') + 1));
                var cgid = queryParams.get('cgid');
                var siteID = $('header.main-header').attr('data-siteid');
                var refinementType = $(this).attr('refinement-type');
                var refinementValue = $(this).attr('refinement-value');
                // Check if the URL contains the 'prefn' query parameter
                var hasPrefn = Array.from(queryParams.keys()).some(function (key) {
                    return key.startsWith('prefn');
                });
                var existingValues = window.localStorage.getItem("filterPills");
                //Checks if there is any selected filters
                if (hasPrefn) {
                    if (existingValues) {
                        //checks if there is any filter to remove
                        if ($(this).parent().hasClass('filter-value') || $(this).parent().hasClass('swatch-filter')) {

                            var selectedFilters = existingValues.split(',');
                            var filterToRemove = siteID + "_" + cgid + "_" + refinementType + "_" + refinementValue;
                            var index = selectedFilters.indexOf(filterToRemove);
                            if (index > -1) {
                                selectedFilters.splice(index, 1);
                            }
                            // Join the updated array back into a string
                            existingValues = selectedFilters.join(',');
                            window.localStorage.removeItem("filterPills");
                        } else {
                            // Append the new value to the existing values
                            existingValues += "," + siteID + "_" + cgid + "_" + refinementType + "_" + refinementValue;
                        }
                    } else {
                        existingValues = siteID + "_" + cgid + "_" + refinementType + "_" + refinementValue;
                    }
                    window.localStorage.setItem("filterPills", existingValues);
                } else {
                    window.localStorage.setItem("filterPills", '');
                    window.localStorage.removeItem("filterPills");
                }

                $.when(
                    $.ajax({
                        url: refinementUrl,
                        data: {
                            page: $('.grid-footer').data('page-number'),
                            selectedUrl: refinementUrl,
                            lastSelected: existingValues,
                            selectedFilters: existingValues
                        },
                        method: 'GET',
                        success: function (response) {
                            // Replace refinement column
                            var $html = $('<div>').append($.parseHTML(response));
                            var $refinmentLength = $html.find('.refinement-bar').length;
                            if ($refinmentLength > 0) {
                                var $htmlRefinement = $html.find('.refinement-bar').children();
                                if ($htmlRefinement.children().length > 1) {
                                    $('.refinement-bar').html($htmlRefinement[0]);
                                } else {
                                    $('.refinement-bar').html($htmlRefinement);
                                }
                            } else if ($refinmentLength === 0) {
                                $this.parent('li').remove();
                                $('.filter-apply-button').addClass('d-none');
                                $('.filter-no-products-button').removeClass('d-none');
                                lastfilterflag = true;
                            }

                            updatePageUrlParams(refinementUrl);
                            parseResults(
                                response,
                                countflag,
                                lastfilterflag
                            );
                            // load star ratings on filter
                            yotpo.refreshWidgets();

                            setTimeout(function () {
                                showYotpoStarReviews();
                            }, 700);

                            $.spinner().stop();
                            if (lastfilterflag) {
                                $('#refineBar-drawer').drawer('hide');
                            }

                            /* For ADA focus while applying/removing filters*/
                            if ($(parentDiv).find('button[refinement-type="' + refinementType + '"][refinement-value="' + refinementValue + '"]:visible').length > 0) {
                                $(parentDiv).find('button[refinement-type="' + refinementType + '"][refinement-value="' + refinementValue + '"]:visible').focus();
                            } else if ($(parentDiv).find('button:visible').length > 0) {
                                $(parentDiv).find('button:first').focus();
                            } else {
                                    $('.refinement-bar:visible button:first').focus();
                            }
                        },
                        error: function () {
                            $.spinner().stop();
                        },
                    })
                );
            }
        );
    },
    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document).on(
            'click',
            '.secondary-bar button.reset',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                var isReset = $(this).hasClass('reset');
                var refinementUrl = $(this).data('href');
                if (isReset) {
                    var filterPills = window.localStorage.getItem("filterPills");

                    if (filterPills) {
                        // Extract the query parameters from the URL
                        var queryParams = new URLSearchParams(refinementUrl.slice(refinementUrl.indexOf('?') + 1));
                        var cgid = queryParams.get('cgid');
                        var siteID = $('header.main-header').attr('data-siteid');
                        var filterToRemove = siteID + "_" + cgid;
                        filterPills = filterPills.split(",");
                        var filteredArray = filterPills.filter(function (value) {
                            return !value.startsWith(filterToRemove);
                        });
                        window.localStorage.removeItem("filterPills");
                        window.localStorage.setItem("filterPills", filteredArray.join(","));
                    }
                } else {
                    refinementUrl = window.location.href;
                }

                $.when(
                    $.ajax({
                        url: refinementUrl,
                        data: {
                            page: $('.grid-footer').data('page-number'),
                            selectedUrl: refinementUrl,
                            lastSelected: $(this).attr('refinement-value')
                        },
                        method: 'GET',
                        success: function (response) {
                            // Replace refinement column
                            var $html = $('<div>').append($.parseHTML(response));
                            var $htmlRefinement = $html.find('.refinement-bar').children();
                            if ($htmlRefinement.children().length > 1) {
                                $('.refinement-bar').html($htmlRefinement[0]);
                            } else {
                                $('.refinement-bar').html($htmlRefinement);
                            }
                            updatePageUrlParams(refinementUrl);
                            parseResults(response, false, false);
                            // load star ratings after filter apply
                            yotpo.refreshWidgets();

                            setTimeout(function () {
                                showYotpoStarReviews();
                            }, 700);

                            $.spinner().stop();
                        },
                        error: function () {
                            $.spinner().stop();
                        },
                    })
                );
            }
        );

        $(document).on('click', '.filter-apply-button', function () {
            $('.drawer-header .close').trigger('click');
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.content-search').on('click', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.show-more-content').on('click', 'button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    showOverlayContentSlot: function () {
        // Display category content slot otherwise show global
        if ($('.contentslot-category').children().length > 0) {
            $('.contentslot-category').removeClass('d-none');
        } else {
            $('.contentslot-global').removeClass('d-none');
        }
    },

    refinementSearch: function () {
        $('.refinement-bar').on('keyup', '.refinement-search', function () {
            var searchValue = $(this).val();
            var refinementValues = $(this)
                .closest('.card-body')
                .find('.values')
                .children();

            refinementValues.each(function () {
                var value = $(this).attr('data-value')
                    ? $(this).attr('data-value').toLowerCase()
                    : '';
                if (value.indexOf(searchValue.toLowerCase()) !== -1) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        });
    },
    toggleBrandDescription: function () {
        var descriptionContainer = $('.category-description .description-text');

        function removeOverflowText($element) {
            var text = $element.html();
            var words = text.split(' ');
            var elementInnerHeight = $element.innerHeight();
            var popped;
            while ($element[0].scrollHeight > elementInnerHeight) {
                popped = words.pop();
                $element.html(words.join(' '));
            }
        }

        function initiate() {
            $('.text-actionButtons .actionButtons').removeAttr('style');
            $('.category-description .description-text').removeClass('hide-text');
            var totalHeight = descriptionContainer.height();
            var lineHeight = descriptionContainer.css('line-height');
            if (totalHeight > parseInt(lineHeight, 10) * 5) {
                descriptionContainer.addClass('hide-text');
                $('.text-actionButtons .more').show();
                removeOverflowText(descriptionContainer);
            }

            // check if any filterPill exists, clear it if category page is loaded
            window.localStorage.setItem("filterPills", '');
            window.localStorage.removeItem("filterPills");
        }

        $(document).ready(initiate());

        $('.text-actionButtons').on('click', '.more', function () {
            descriptionContainer.removeClass('hide-text');
            descriptionContainer.html($(this).data('category-desc'));
            $(this).hide();
            $('.text-actionButtons .less').show();
        });
        $('.text-actionButtons').on('click', '.less', function () {
            descriptionContainer.addClass('hide-text');
            removeOverflowText(descriptionContainer);
            $(this).hide();
            $('.text-actionButtons .more').show();
        });
    },

    pageAnchorScroll: function () {
        $('.scrollToTop').on('click', function () {
            var selector = $(this).attr('data-scrollto');
            scrollToView(selector);
        })
    },

    redirectPageScroll: function () {
        $(window).on('load', function () {
            var queryString = window.location.search;
            queryString =
                queryString && queryString.indexOf('?') > -1
                    ? queryString.split('?')[1]
                    : '';
            var queryParam = getQueryParams(queryString);
            if (queryParam && queryParam.scrollTo) {
                scrollToView(queryParam.scrollTo);
            }
        })
    },
    rcTabContent: function () {
        $('.tab-options').on('click', function () {
            if (!$(this).hasClass('active')) {
                $('.tab-options.active').removeClass('active');
                $(this).addClass('active');
                var tabID = $(this).data('tabid');
                $('.tab-content.tab-active').removeClass('tab-active');
                $('.tab-content[data-tab-id="' + tabID + '"]').addClass('tab-active');
            }
        })
    },

    swatchAdaptScreensize: swatchAdaptScreensize,
    displaySearchRefinement: displaySearchRefinement,
    initProductTilejs: initProductTilejs,
    showYotpoStarReviews: showYotpoStarReviews
};